import { HomeEditOutlineIcon } from './HomeEditOutlineIcon';

/**
 * author: Simran
 * id B56AB73F-0A3C-4562-88DF-ED70B51877DE
 * name home-edit-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-edit-outline.svg
 * tags
 * - Home Automation 
 * - Edit / Modify 
 */
export const HouseEditOutlineIcon = HomeEditOutlineIcon;
export default HouseEditOutlineIcon